import { Body, Button, Stack, useModals } from '@qred/components-library';
import React from 'react';
import { useSelector } from 'react-redux';
import NextButton from '~/components/shared/Stepper/components/NextButton';
import useTranslate from '~/hooks/useTranslate';
import { RootState } from '~/store';
import { ApiStatus } from '~/store/types/sharedTypes';
import { UniqueSellingPoints } from '../UniqueSellingPoints/UniqueSellingPoints';

export interface UniqueSellingPointsModalProps {
  handleBoostApplication: () => void;
}

export const UniqueSellingPointsModal = ({
  handleBoostApplication,
}: UniqueSellingPointsModalProps) => {
  const apiStatus = useSelector(
    (state: RootState) => state.loanApplication.apiStatus
  );
  const t = useTranslate();
  const { closeModal } = useModals();

  return (
    <Stack spacing={'xxl'}>
      <Stack spacing={'xl'}>
        <Body size="lg">{t('Onboarding.CheckpointUSPDescription')}</Body>
        <UniqueSellingPoints />
      </Stack>
      <Stack spacing={'sm'}>
        <NextButton
          label="Onboarding.CheckpointImproveApplicationButtonText"
          isLoading={apiStatus.patch === ApiStatus.Started}
          action={handleBoostApplication}
          rightIcon="east"
        />
        <Button
          variant="tertiary"
          onClick={() => closeModal('unique-selling-points-modal')}
        >
          {t('Close')}
        </Button>
      </Stack>
    </Stack>
  );
};
